(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vendor-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vh]').forEach((root) => {
    const track = root.querySelector('[data-vh-track]');
    const dots = root.querySelectorAll('[data-vh-dot]');
    const total = parseInt(root.dataset.count || '0', 10);
    if (total <= 1 || !track) return;
    // Read CSS custom properties so the JS stays in sync with stylesheet
    const styles = getComputedStyle(root);
    const slideWidth = styles.getPropertyValue('--vh-slide-width').trim() || '90%';
    const peek = styles.getPropertyValue('--vh-slide-peek').trim() || '5%';
    const gap = styles.getPropertyValue('--vh-slide-gap').trim() || '10px';
    let index = 0;
    const goTo = (i) => {
      index = (i + total) % total;
      // Position so active slide is centered with peek on each side
      track.style.transform = `translate3d(calc(${peek} - ${index} * (${slideWidth} + ${gap})), 0, 0)`;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    // Start on slide 2 (index 1) when at least 2 slides exist
    goTo(total >= 2 ? 1 : 0);
    root.querySelector('[data-vh-prev]')?.addEventListener('click', () => goTo(index - 1));
    root.querySelector('[data-vh-next]')?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((d) => d.addEventListener('click', () => {
      goTo(parseInt(d.dataset.vhDot || '0', 10));
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
